import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Loader from "../../../Dashboard/Loader";
import Menu from "../../../Menu/Menu";

const SingleProject = () => {
  const { id } = useParams();
  const [project, setProject] = useState({});
  const [loader, setLoader] = useState(false);
  const [imgHeight, setImgHeight] = useState(false);
  useEffect(() => {
    let cancel = false;
    setLoader(true);
    axios
      .get(`https://infinite-cliffs-70499.herokuapp.com/projects/${id}`)
      .then((res) => {
        if (cancel) return;
        setProject(res.data);
        setLoader(false);
      })
      .finally(() => setLoader(false));

    return () => {
      cancel = true;
    };
  }, [id]);
  const handleImg = (e) => {
    e.target.height > 900 ? setImgHeight(true) : setImgHeight(false);
  };
  return (
    <div className="container mx-auto min-h-screen py-20 md:py-16 px-3 md:px-0">
      <Menu />
      <div className="text-center">
        <h3 className="text-4xl md:text-5xl font-semibold">Project Details</h3>
      </div>
      {loader ? (
        <Loader />
      ) : (
        <div className="flex flex-col md:flex-row mt-10 gap-5">
          <div className="md:w-3/5 md:mt-20">
            <h2 className="text-3xl">
              <span className="font-semibold">Name: </span>
              {project.name}
            </h2>
            <ul className="space-y-3 my-8 ">
              <h3 className="text-2xl font-semibold">Overview :</h3>
              {project?.description?.split("./n")?.map((detas, indx) => (
                <li key={indx} className="block">
                  {indx + 1}. {detas}
                </li>
              ))}
            </ul>
            <h3 className="my-8 ">
              <span className="text-xl font-semibold">Technology used: </span>
              {project.usedTech}
            </h3>
            <a
              href={project.liveServer}
              className="bg-gray-200 text-blue-900 font-medium px-5 py-2 border hover:border-white hover:bg-transparent hover:text-white transition-all"
            >
              Watch Live Server
            </a>
            <a
              href={project?.codeLink ? project?.codeLink : "#"}
              className="bg-gray-200 text-blue-900 font-medium px-5 py-2 border hover:border-white hover:bg-transparent hover:text-white transition-all ml-5"
            >
              Github Code Link
            </a>
          </div>
          <div
            className={`md:w-1/3 mt-16 md:mt-0 rounded ${
              imgHeight && "h-screen overflow-y-scroll"
            }   `}
          >
            <img
              onLoad={handleImg}
              className="w-full"
              src={`data:image/jpeg;base64,${project?.img}`}
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleProject;
